import { useContext } from 'react';
import { AuthContext } from '../../contexts/contexts';

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === undefined) {
    throw new Error('useAuth must be used within a AuthProvider');
  }

  const {
    user,
    isSignedIn,
    signIn,
    signOut,
    signUp,
    verify,
    resendConfirmationCode,
    forgotPassword,
    resetPassword,
  } = context;

  return {
    user,
    isSignedIn,
    signIn,
    signOut,
    signUp,
    verify,
    resendConfirmationCode,
    forgotPassword,
    resetPassword,
  };
};
